import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { api } from "../config";

const CkEditor = ({ data, onChange, onReady }) => {
  const editorRef = useRef();
  const [editorLoaded, setEditorLoaded] = useState(false);
  const { CKEditor, ClassicEditor } = editorRef.current || {};

  const upload_endpoint = "storage-files";

  useEffect(() => {
    editorRef.current = {
      CKEditor: require("@ckeditor/ckeditor5-react").CKEditor,
      ClassicEditor: require("@ckeditor/ckeditor5-build-classic"),
    };
    setEditorLoaded(true);
  }, []);

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();

          loader.file.then((file) => {
            body.append("foldername", "content");
            body.append("files", file);

            axios
              .post(`${api.MEDIA_URL}/${upload_endpoint}`, body, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response) => {
                resolve({
                  default: `${api.MEDIA_URL}/media/${response.data[0].filename}`,
                });
              })
              .catch((error) => {
                console.error("Upload error:", error);
                reject(error);
              });
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return new uploadAdapter(loader);
    };
  }

  const addCustomClasses = (htmlContent) => {
    // Menggunakan DOMParser untuk mengubah string HTML menjadi objek DOM
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");

    // Memilih semua tag <ol> dan <ul> dalam dokumen
    const olElements = doc.querySelectorAll("ol");
    const ulElements = doc.querySelectorAll("ul");

    // Menambahkan kelas khusus ke setiap elemen <ol>
    olElements.forEach((ol) => {
      ol.classList.add("my-ck-ol-class");
    });

    // Menambahkan kelas khusus ke setiap elemen <ul>
    ulElements.forEach((ul) => {
      ul.classList.add("my-ck-ul-class");
    });

    let start_index = doc.documentElement.outerHTML.indexOf("<body>") + "<body>".length;
    let end_index = doc.documentElement.outerHTML.indexOf("</body>");

    // Ambil konten di dalam tag <body>
    let bodyContent = doc.documentElement.outerHTML.substring(start_index, end_index);
    // Mengembalikan konten HTML yang telah dimodifikasi
    return bodyContent;
  };

  return editorLoaded ? (
    <CKEditor
      editor={ClassicEditor}
      data={data}
      config={{
        extraPlugins: [uploadPlugin],
        extraAllowedContent: "ol[class]",
      }}
      onReady={onReady}
      onChange={(event, editor) => {
        const data = editor.getData();
        const modifiedData = addCustomClasses(data);
        onChange(modifiedData);
      }}
      onBlur={(event, editor) => {
        //
      }}
      onFocus={(event, editor) => {
        //
      }}
    />
  ) : (
    <div>Editor loading</div>
  );
};

export default CkEditor;
